import { useState, useRef } from 'react';
import { useOrder } from '../hooks/useOrders';
import { handleMultipleFileUpload } from '../../utils/csvUtils';
import { useNavigate } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Container, Box, Pagination, Alert, TextField, InputAdornment, CircularProgress } from '@mui/material';
import { routingPath } from '../../utils/path';
import SearchIcon from '@mui/icons-material/Search';

export default function Orderlist() {
  const { orders, page, setPage, totalPages, setSearchQuery, error } = useOrder();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [importMessage, setImportMessage] = useState<string | null>(null);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleFileUploadWithMessage = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage("");
    setLoading(true);
    const message = await handleMultipleFileUpload(event);
    setImportMessage(message);
    setLoading(false);
  };

  const handleSearch = () => {
    setSearchQuery(searchText);
    setPage(1);
  };

  return (
      <Container>
        <h2>{"受注一覧"}</h2>
        <Box display="flex" justifyContent="space-between" mb={5}>
          <TextField
            variant="outlined"
            placeholder="項目の部分一致検索"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button onClick={handleSearch}>
                    <SearchIcon />
                  </Button>
                </InputAdornment>
              ),
            }}
            sx={{ maxHeight: 10 }}
          />
          <Button variant="contained" color="primary" onClick={() => fileInputRef.current?.click()}>
            CSV一括インポート
          </Button>
          <input
            type="file"
            accept=".csv"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileUploadWithMessage}
            multiple
          />
        </Box>
      {loading && (
        <Box display="flex" justifyContent="center" mt={4} mb={4}>
          <CircularProgress />
          <Box ml={2} />
          <Box mt={1}>
            {"ローディング中はページのリロードをしないでください。"}
          </Box>
        </Box>
      )}
      {importMessage && (
        <Alert severity={importMessage.includes("正常") ? "success" : "error"} sx={{ mt: 4, mb: 4 }}>
          {importMessage}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mt: 4, mb: 4 }}>
          {error}
        </Alert>
      )}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>受注番号</TableCell>
              <TableCell>受注日時</TableCell>
              <TableCell>納品希望日</TableCell>
              <TableCell>顧客コード<br /> 顧客名</TableCell>
              <TableCell>配送先コード<br />配送先名</TableCell>
              <TableCell>連絡事項</TableCell>
              <TableCell>商品点数<br />数量合計</TableCell>
              <TableCell>詳細</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow key={index}>
                <TableCell>{order.受注番号}</TableCell>
                <TableCell>{order.受注日時.replace("T", " ")}</TableCell>
                <TableCell>{order.納品希望日}</TableCell>
                <TableCell>
                  {order.顧客コード}
                  <br />
                  {order.顧客名}
                </TableCell>
                <TableCell>
                  {order.配送先コード}
                  <br />
                  {order.配送先名}
                </TableCell>
                <TableCell style={{ maxWidth: '250px', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                  {order['コメント（備考）']}
                </TableCell>
                <TableCell>
                  {order.商品点数}
                  <br />
                  {order.数量合計}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    onClick={() =>
                      navigate(`${routingPath.admin.orderList}/${order.受注番号}`, {
                        state: {
                          itemCount: order.商品点数,
                          itemSum: order.数量合計,
                        },
                      })
                    }
                  >詳細</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination count={totalPages} page={page} onChange={handlePageChange} />
        </Box>
      </Container>
  );
}
